var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0483 0.576172C20.0881 0.576172 25.8019 6.25851 25.8019 13.2983C25.8019 20.3381 20.0881 26.0519 13.0483 26.0519C6.00851 26.0519 0.326172 20.3381 0.326172 13.2983C0.326172 6.25851 6.00851 0.576172 13.0483 0.576172ZM13.0483 10.804L16.647 7.20528C18.2885 5.5638 20.814 8.05766 19.1724 9.69909L15.5737 13.2978L19.1724 16.8965C20.8139 18.538 18.2885 21.0635 16.647 19.4219L13.0483 15.8232L9.44957 19.4219C7.80809 21.0634 5.31408 18.538 6.95576 16.8965L10.5545 13.2978L6.95576 9.69909C5.31427 8.05761 7.80813 5.5636 9.44957 7.20528L13.0483 10.804Z",
    fill: "#0F5671"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel-icon.6ee4e565443803210a57e8f7c65a2efb.svg";
export { ForwardRef as ReactComponent };